<template>
  <div class="collection-blacklist">
    <el-card class="box-card">
      <div class="set-box">
        <div class="title">
          <img style="width: 20px;margin-right: 10px;" src="@/assets/images/blacklist_icon.png" alt>
          <span>黑名单设置</span>
          <el-button style="margin-left: 20px;" type="primary" :plain="!isEdit" size="mini" @click="clickEdit">{{isEdit?'保存':'修改'}}</el-button>
        </div>
        <div class="flex">
          <div class="mr-40">
            <div class="mb-20">
              <span class="lable">启用黑名单管理</span>
              <el-switch
                :disabled="!isEdit"
                inactive-color="#bebebe"
                @change="handleSwitch('left')"
                v-model="blacklistConfig.staffBlacklistEnable"
              ></el-switch>
              <span class="tip">说明：启用后，在下面黑名单列表的人员不可收款作为旧机收款人</span>
            </div>
            <div class="flex">
              <span class="lable">黑名单收款审核人</span>
              <el-checkbox-group v-model="blacklistConfig.staffBlacklistAuditRole" style="margin-top: 2px;" :disabled="!isEdit" class="mr-40">
                <el-checkbox label="02">本店所属总监</el-checkbox>
                <el-checkbox label="01">指定管理人员</el-checkbox>
              </el-checkbox-group>
              <div class="add-txt" v-if="blacklistConfig.staffBlacklistAuditRole.includes('01')">
                <span>已添加</span>
                <span class="add-btn" style="margin: 0;" @click="seeCompanyDiaShow = true">{{blacklistConfig.staffBlacklistAuditIds?blacklistConfig.staffBlacklistAuditIds.length:0}}</span>
                <span>个</span>
                <span class="add-btn" v-show="isEdit" @click="selectCompanyDiaShow = true">添加</span>
              </div>
            </div>
          </div>
          
          <div style="position: relative;">
            <div class="line"></div>
            <div class="mb-20">
              <span class="lable">启用自动更新黑名单</span>
              <el-switch
                :disabled="!isEdit"
                inactive-color="#bebebe"
                @change="handleSwitch('left')"
                v-model="blacklistConfig.staffBlacklistEnableSync"
              ></el-switch>
              <span class="tip">说明：启用后，新建店员后，默认将店员同步到黑名单数据中</span>
            </div>
            <div class="flex" v-if="blacklistConfig.staffBlacklistEnableSync">
              <span class="lable">设置更新角色</span>
              <el-checkbox-group v-model="blacklistConfig.staffBlacklistSyncRole" style="margin-top: 2px;" :disabled="!isEdit" class="mr-40">
                <el-checkbox label="03">店长</el-checkbox>
                <el-checkbox label="04">店员</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style="height: 21px;" v-else></div>
          </div>
        </div>
        
        
      </div>
    </el-card>
    
    <GlobalChunkNo
        icon="search"
        title="黑名单管理"
    >
      <div slot="filter">
        <From />
      </div>

      <Table />
    </GlobalChunkNo>
    <el-dialog
      title="操作提示"
      :visible.sync="saveDialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div
        style="font-size: 18px;color: #666666;text-align: center;height: 100px;line-height: 100px;"
      >
      是否确认保存黑名单设置？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="saveDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saveSureBtnLoading"
          @click.native="saveSureHandleSuccess"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <SeeCompanyDia
      v-if="seeCompanyDiaShow"
      :dialogVisible="seeCompanyDiaShow"
      :isEdit="isEdit"
      :auditIds="blacklistConfig.staffBlacklistAuditIds"
      @close="closeSeeCompanyDia"
      @delMachine="delMachine"
    ></SeeCompanyDia>
    <SelectCompanyDia
      v-if="selectCompanyDiaShow"
      :auditIds="blacklistConfig.staffBlacklistAuditIds"
      :dialogVisible="selectCompanyDiaShow"
      @close="closeSelectCompanyDia"
      @addCompanySubmit="addCompanySubmit"
    ></SelectCompanyDia>
  </div>
</template>

<script>
import _api from "@/utils/request";
import From from './From'
import Table from './Table'
import SeeCompanyDia from "./dialog/SeeCompanyDia.vue";
import SelectCompanyDia from "./dialog/SelectCompanyDia.vue";
export default {
  name: 'storeManage-list',
  components: {From,Table,SeeCompanyDia,SelectCompanyDia},
  data(){
    return{
      blacklistConfig: {
        staffBlacklistAuditIds: [],
        staffBlacklistAuditRole: [],
        staffBlacklistEnable: false,
        staffBlacklistEnableSync: false,
        staffBlacklistSyncRole: []
      },
      isEnable: true,
      checkList: ['01'],
      isEdit: false,
      seeCompanyDiaShow: false,
      selectCompanyDiaShow: false,
      saveDialogVisible: false,
      saveSureBtnLoading: false,
    }
  },
  created(){
    this.getBlacklistConfig()
  },
  methods:{
    getBlacklistConfig() {
      _api.getBlacklistConfig().then(res => {
        console.log(res);
        if(res.code === 1){
          if(!res.data.staffBlacklistAuditRole){
            res.data.staffBlacklistAuditRole = []
          }
          if(!res.data.staffBlacklistSyncRole){
            res.data.staffBlacklistSyncRole = []
          }
          this.blacklistConfig = res.data
        }
      })
    },
    handleSwitch() {

    },
    clickEdit() {
      if(!this.isEdit){
        this.isEdit = true
      }else{
        this.saveDialogVisible = true
      }
    },
    closeSeeCompanyDia() {
      this.seeCompanyDiaShow = false
    },
    closeSelectCompanyDia() {
      this.selectCompanyDiaShow = false
    },
    saveSureHandleSuccess() {
      this.saveSureBtnLoading = true
      _api.setBlacklistConfig(this.blacklistConfig).then(res => {
        if(res.code === 1){
          this.$message.success('保存成功')
          this.saveDialogVisible = false
          this.isEdit = false
        }
      }).finally(() => {
        this.saveSureBtnLoading = false
      });
    },
    addCompanySubmit(arr) {
      arr.forEach(item => {
        this.blacklistConfig.staffBlacklistAuditIds.push(item.id)
      })
      this.closeSelectCompanyDia()
    },
    delMachine(id) {
      this.blacklistConfig.staffBlacklistAuditIds = this.blacklistConfig.staffBlacklistAuditIds.filter(item => item !== id);
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.collection-blacklist{
  .flex{
    display: flex;
    align-items: center;
  }
  .mr-40{
    margin-right: 40px;
  }
  .mb-20{
    margin-bottom: 20px;
  }
  /deep/.el-card.is-always-shadow{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  }
  .box-card{
    margin-bottom: 20px;
  }
  .set-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title{
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-bottom: 18px;
      color: #333333;
      font-weight: 700;
    }
    .lable{
      font-size: 16px;
      color: #333333;
      margin-right: 10px;
    }
    .tip{
      font-size: 14px;
      color: #ff687b;
      margin-left: 10px;
    }
    .add-txt{
      font-size: 14px;
      .add-btn{
        font-size: 14px;
        color: #0981FF;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
  .line{
    position: absolute;
    width: 1px;
    background: #E4ECFD;
    height: 60px;
    left: -20px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
